import {FormControl, InlineLink, Text} from '@primer/react-brand/esm'

import type {GeneralConsentLanguageProps} from './types'
import {getAnalyticsEvent} from '../../../../../../lib/utils/analytics'

import {t} from '../../../../../../lib/utils/localization'

export default function Default({fieldName, privacyStatementHref, children}: GeneralConsentLanguageProps) {
  return (
    <FormControl>
      {/* Include children first for focus order */}
      {children}

      <FormControl.Label htmlFor={fieldName} data-testid="label">
        <Text weight="semibold">
          {t(
            'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the',
          )}{' '}
          <InlineLink
            {...getAnalyticsEvent({
              action: t('GitHub Privacy Statement'),
              tag: 'hyperlink',
              context: 'consent_language_default',
              location: 'form',
            })}
            href={privacyStatementHref}
          >
            {t('GitHub Privacy Statement')}
          </InlineLink>{' '}
          {t('for more details.')}
        </Text>
      </FormControl.Label>
    </FormControl>
  )
}
